import type { Entry as UserEntry } from "@tandemdiabetes/sugarmate-api-react-client"
import type { RxCollection } from "rxdb"
import { useRxCollection } from "rxdb-hooks"
import { CollectionKey } from "src/types"

export function useUserEntriesCollection(): RxCollection<UserEntry> | null {
  return useRxCollection<UserEntry>(CollectionKey.UserEntry)
}
